import React, {Component} from 'react';

// components
import Number from '../StepContent/Number';
import Inner from '../StepContent/Inner';
import {Field} from "redux-form";

import Autosuggest from 'react-autosuggest';

const required = value => value ? undefined : 'Required';

class Step2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            locationSuggestions: [],
            firmSuggestions: []
        };

        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.getSuggestions = this.getSuggestions.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getSuggestionValue = (suggestion) => {
        return suggestion
    };

    getSuggestions = (value, type) => {
        /* type: locatios === 0 | firms === 1 */
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        if (type === 0) {
            return inputLength === 0 ? [] : locations.filter(location =>
                location.toLowerCase().slice(0, inputLength) === inputValue
            );
        } else {
            return inputLength === 0 ? [] : firms.filter(location =>
                location.toLowerCase().slice(0, inputLength) === inputValue
            );
        }
    };

    onLocationSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            locationSuggestions: this.getSuggestions(value, 0)
        });
    };

    onLocationSuggestionsClearRequested = () => {
      this.setState({
          locationSuggestions: []
      });
    };

    onFirmSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            firmSuggestions: this.getSuggestions(value, 1)
        });
    };

    onFirmSuggestionsClearRequested = () => {
        this.setState({
            firmSuggestions: []
        });
    };

    renderSuggestion(suggestion) {
        return (
            <span>{suggestion}</span>
        );
    }

    onChange = (event, { newValue, method }, input) => {
        input.onChange(newValue);
        input.onBlur(newValue);
    };

    renderAutoCompleteTextFiled({input, suggestions, context, type, title, meta: {touched, error}}) {
        /* type: locatios === 0 | firms === 1 */
        return <div className={`inputOuter ${touched && error ? 'forEror' : ''}`}>
            <span>{title}</span>
            <div className="inputWrap">
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={type === 0 ? context.onLocationSuggestionsFetchRequested : context.onFirmSuggestionsFetchRequested}
                    onSuggestionsClearRequested={type === 0 ? context.onLocationSuggestionsClearRequested : context.onFirmSuggestionsClearRequested}
                    getSuggestionValue={context.getSuggestionValue}
                    renderSuggestion={context.renderSuggestion}
                    inputProps={{
                        value: input.value,
                        onChange: (event, { newValue, method }) => context.onChange(event, { newValue, method }, input)
                    }}/>
            </div>
            <p className="text-danger">Enter a valid input</p>
        </div>;
    }

    renderCombobox({input, title, options, label, type, meta: {touched, error}}) {
        return <div className={`inputOuter ${touched && error ? 'forEror' : ''}`}>
                    <span>{title}</span>
                    <div className="inputWrap">
                        <select {...input} className="custom-select form-control">
                            <option></option>
                            {options.map((option, index) => (
                                <option key={index} value={index}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                    <p className="text-danger">Enter a valid input</p>
                </div>;
    }

    render() {
        let classNames = (this.props.classDone) ? 'stepB ' : 'stepB disableAll';
        if (this.props.classDone && this.props.className) {
            classNames += ' stepSucc';
        }

        const { locationSuggestions, firmSuggestions } = this.state;

        return (
            <div className={classNames}>
                <Number number='02'/>
                <Inner>
                    <h3>Profile&nbsp;
                        <span>questions </span></h3>
                    <div className="proQt">
                        <div className="clearfix inputTwo">
                            <Field name="location"
                                   suggestions={locationSuggestions}
                                   context={this}
                                   title="What is your primary location?"
                                   type={0}
                                   component={this.renderAutoCompleteTextFiled}
                                   validate={[required]}
                            />
                            <Field name="is_freelancer"
                                label={'Lorem lipsum'}
                                title="Are you currently a freelancer?"
                                options={['Yes', 'No']}
                                component={this.renderCombobox}
                                validate={[required]}
                            />
                        </div>
                        <div className="clearfix inputTwo">
                            <Field name="industry_experience"
                                   label={'Lorem lipsum'}
                                   title="How many years experience do you have?"
                                   options={
                                     ['1',
                                     '2',
                                     '3',
                                     '4',
                                     '5',
                                     '6',
                                     '7',
                                     '8',
                                     '9',
                                     '10',
                                     '11-15',
                                     'Over 15']
                                   }
                                   component={this.renderCombobox}
                                   validate={[required]}
                            />
                            <Field name="availability"
                                label={'Lorem lipsum'}
                                title="When will you be available for projects?"
                                options={
                                    ['I\'m available now',
                                        'In the next fortnight',
                                        'In the next month',
                                        'In the next three months',
                                        'In the next six months',
                                        'After six months']
                                }
                                component={this.renderCombobox}
                                validate={[required]}
                            />
                        </div>
                        <div className="forNext">
                            <button type="button"
                                    disabled={this.props.invalidSteps.indexOf("Step2") !== -1}
                                    onClick={() => this.props.onClickNext()}
                                    name="button" className="btn btn-danger text-uppercase">
                                next
                            </button>
                        </div>
                    </div>
                </Inner>
            </div>
        );
    }
}

const locations = [
    'Avon',
    'Bedfordshire',
    'Berkshire',
    'City of Bristol',
    'Buckinghamshire',
    'Cambridgeshire',
    'Cambridgeshire and Isle of Ely',
    'Cheshire',
    'Cleveland',
    'Cornwall',
    'Cumberland',
    'Cumbria',
    'Derbyshire',
    'Devon',
    'Dorset',
    'Durham (County Durham)',
    'East Suffolk',
    'East Sussex',
    'Essex',
    'Gloucestershire',
    'Greater Manchester',
    'Hampshire',
    'Hereford and Worcester',
    'Herefordshire',
    'Hertfordshire',
    'Humberside',
    'Huntingdon and Peterborough',
    'Huntingdonshire',
    'Isle of Ely',
    'Isle of Wight',
    'Kent',
    'Lancashire',
    'Leicestershire',
    'Lincolnshire',
    'Lincolnshire, Parts of Holland',
    'Lincolnshire, Parts of Kesteven',
    'Lincolnshire, Parts of Lindsey',
    'Merseyside',
    'Middlesex',
    'Norfolk',
    'Northamptonshire',
    'Northumberland',
    'North Humberside',
    'North Yorkshire',
    'Nottinghamshire',
    'Oxfordshire',
    'Soke of Peterborough',
    'Rutland',
    'Shropshire',
    'Somerset',
    'South Humberside',
    'South Yorkshire',
    'Staffordshire',
    'Suffolk',
    'Surrey',
    'Sussex',
    'Tyne and Wear',
    'Warwickshire',
    'West Midlands',
    'Westmorland',
    'West Suffolk',
    'West Sussex',
    'West Yorkshire',
    'Wiltshire',
    'Worcestershire',
    'Yorkshire',
    'Yorkshire, East Riding',
    'Yorkshire, North Riding',
    'Yorkshire, West Riding',
    'Antrim',
    'Armagh',
    'City of Belfast',
    'Down',
    'Fermanagh',
    'City of Derry',
    'Tyrone',
    'City of Aberdeen',
    'Aberdeenshire',
    'Angus (Forfarshire)',
    'Argyll',
    'Ayrshire',
    'Banffshire',
    'Berwickshire',
    'Bute',
    'Caithness',
    'Clackmannanshire',
    'Cromartyshire',
    'Dumfriesshire',
    'Dunbartonshire (Dumbarton)',
    'City of Dundee',
    'East Lothian (Haddingtonshire)',
    'City of Edinburgh',
    'Fife',
    'City of Glasgow',
    'Inverness-shire',
    'Kincardineshire',
    'Kinross-shire',
    'Kirkcudbrightshire',
    'Lanarkshire',
    'Midlothian (County of Edinburgh)',
    'Moray (Elginshire)',
    'Nairnshire',
    'Orkney',
    'Peeblesshire',
    'Perthshire',
    'Renfrewshire',
    'Ross and Cromarty',
    'Ross-shire',
    'Roxburghshire',
    'Selkirkshire',
    'Shetland (Zetland)',
    'Stirlingshire',
    'Sutherland',
    'West Lothian (Linlithgowshire)',
    'Wigtownshire',
    'Anglesey',
    'Brecknockshire',
    'Caernarfonshire',
    'Cardiganshire',
    'Carmarthenshire',
    'Clwyd',
    'Denbighshire',
    'Dyfed',
    'Flintshire',
    'Glamorgan',
    'Gwent',
    'Gwynedd',
    'Merionethshire',
    'Mid Glamorgan',
    'Monmouthshire',
    'Montgomeryshire',
    'Pembrokeshire',
    'Powys',
    'Radnorshire',
    'South Glamorgan',
    'West Glamorgan',
    'Wrexham',
    'Aberdeen',
    'Armagh',
    'Bangor',
    'Bath',
    'Belfast',
    'Birmingham',
    'Bradford',
    'Brighton and Hove',
    'Bristol',
    'Cambridge',
    'Canterbury',
    'Cardiff',
    'Carlisle',
    'Chester',
    'Chichester',
    'Coventry',
    'Derby',
    'Dundee',
    'Durham',
    'Edinburgh',
    'Ely',
    'Exeter',
    'Glasgow',
    'Gloucester',
    'Hereford',
    'Inverness',
    'Kingston upon Hull',
    'Lancaster',
    'Leeds',
    'Leicester',
    'Lichfield',
    'Lincoln',
    'Lisburn',
    'Liverpool',
    'Manchester',
    'Newcastle upon Tyne',
    'Newport',
    'Newry',
    'Norwich',
    'Nottingham',
    'Oxford',
    'Peterborough',
    'Plymouth',
    'Portsmouth',
    'Preston',
    'Ripon',
    'Salford',
    'Salisbury',
    'Sheffield',
    'Southampton',
    'St Albans',
    'St Davids',
    'Stirling',
    'Stoke-on-Trent',
    'Sunderland',
    'Swansea',
    'Truro',
    'Wakefield',
    'Wells',
    'Westminster',
    'Winchester',
    'Wolverhampton',
    'Worcester',
    'York',
    'Tokyo/Yokohama',
    'New York Metro',
    'Sao Paulo',
    'Seoul/Incheon',
    'Mexico City',
    'Osaka/Kobe/Kyoto',
    'Manila',
    'Mumbai',
    'Delhi',
    'Jakarta',
    'Lagos',
    'Kolkata',
    'Cairo',
    'Los Angeles',
    'Buenos Aires',
    'Rio de Janeiro',
    'Moscow',
    'Shanghai',
    'Karachi',
    'Paris',
    'Istanbul',
    'Nagoya',
    'Beijing',
    'Chicago',
    'London',
    'Shenzhen',
    'Essen/Düsseldorf',
    'Tehran',
    'Bogota',
    'Lima',
    'Bangkok',
    'Johannesburg/East Rand',
    'Chennai',
    'Taipei',
    'Baghdad',
    'Santiago',
    'Bangalore',
    'Hyderabad',
    'St Petersburg',
    'Philadelphia',
    'Lahore',
    'Kinshasa',
    'Miami',
    'Ho Chi Minh City',
    'Madrid',
    'Tianjin',
    'Kuala Lumpur',
    'Toronto',
    'Milan',
    'Shenyang',
    'Dallas/Fort Worth',
    'Boston',
    'Belo Horizonte',
    'Khartoum',
    'Riyadh',
    'Singapore',
    'Washington',
    'Detroit',
    'Barcelona',
    'Houston',
    'Athens',
    'Berlin',
    'Sydney',
    'Atlanta',
    'Guadalajara',
    'San Francisco/Oakland',
    'Montreal.',
    'Monterey',
    'Melbourne',
    'Ankara',
    'Recife',
    'Phoenix/Mesa',
    'Durban',
    'Porto Alegre',
    'Dalian',
    'Jeddah',
    'Seattle',
    'Cape Town',
    'San Diego',
    'Fortaleza',
    'Curitiba',
    'Rome',
    'Naples',
    'Minneapolis/St. Paul',
    'Tel Aviv',
    'Birmingham',
    'Frankfurt',
    'Lisbon',
    'Manchester',
    'San Juan',
    'Katowice',
    'Tashkent',
    'Fukuoka',
    'Baku/Sumqayit',
    'St. Louis',
    'Baltimore',
    'Sapporo',
    'Tampa/St. Petersburg',
    'Taichung',
    'Warsaw',
    'Denver',
    'Cologne/Bonn',
    'Hamburg',
    'Dubai',
    'Pretoria',
    'Vancouver',
    'Beirut',
    'Budapest',
    'Cleveland',
    'Pittsburgh',
    'Campinas',
    'Harare',
    'Brasilia',
    'Kuwait',
    'Munich',
    'Portland',
    'Brussels',
    'Vienna',
    'San Jose',
    'Damman',
    'Copenhagen',
    'Brisbane',
    'Riverside/San Bernardino',
    'Cincinnati',
    'Accra',
    'Nizhni Novgorod',
    'Phnom Penh',
    'Quito',
    'Leeds/Bradford',
    'Goiania',
    'Donetsk',
    'Stockholm',
    'Virginia Beach',
    'Sacramento',
    'Kansas City',
    'Marseille',
    'Turin',
    'Lyon',
    'San Antonio',
    'Rotterdam',
    'Las Vegas',
    'Milwaukee',
    'Stuttgart',
    'Indianapolis',
    'Glasgow',
    'Lumumbashi',
    'Perth',
    'Providence',
    'Orlando',
    'Columbus',
    'Dublin',
    'Auckland',
    'Lille',
    'Porto',
    'New Orleans',
    'Adelaide',
    'Helsinki',
    'Buffalo',
    'Memphis',
    'Antwerp',
    'Austin',
    'Port Elizabeth',
    'Bridgeport//Stamford',
    'Nice',
    'Salt Lake City',
    'Jacksonville',
    'Calgary',
    'Louisville',
    'Hartford',
    'Ottawa/Hull',
    'Richmond',
    'Edmonton',
    'Toulouse',
    'Charlotte',
    'Bordeaux',
    'Nashville',
    'Oklahoma City',
    'Tucson',
    'Honolulu',
    'Dayton',
    'Rochester',
    'El Paso',
    'Birmingham',
    'Quebec',
    'Omaha',
    'Winnipeg',
    'Vereeniging',
    'Albuquerque',
    'Aachen',
    'Allentown/Bethlehem',
    'Springfield',
    'Akron',
    'Albany',
    'Sarasota//Bradenton',
    'Tulsa',
    'Concord',
    'Abu Dhabi',
    'Nantes',
    'Raleigh',
    'Grand Rapids',
    'New Haven',
    'McAllen',
    'Toulon',
    'Douai/Lens',
    'Toledo',
    'Baton Rouge',
    'Colorado Springs',
    'Worcester',
    'Charleston',
    'Gold Coast',
    'Wichita',
    'Columbia',
    'Knoxville',
    'Ogden',
    'Youngstown',
    'Syracuse',
    'Palm Bay',
    'Scranton',
    'Flint',
    'Harrisburg',
    'Little Rock',
    'Valenciennes',
    'Poughkeepsie',
    'Chattanooga',
    'Augusta',
    'Spokane',
    'Cape Coral',
    'Lancaster',
    'Pensacola',
    'Mobile',
    'Greenville',
    'St Catharines',
    'Aguadilla',
    'Winston/Salem',
    'Tours',
    'Jackson',
    'Durham',
    'Fayetteville',
    'South Bend',
    'Shreveport',
    'Port St Lucie',
    'Canton',
    'Bethune',
    'Avignon',
    'Barnstable Town',
    'Asheville',
    'Bonita Springs / Naples',
    'Huntsville',
    'Hickory',
    'Pau',
    'Londonderry'
];

const firms = [
    'A.T. Kearney',
    'A&G Management Consulting',
    'ABeam',
    'Abacus Consulting',
    'Accenture',
    'Accountor',
    'AlixPartners',
    'Altran',
    'Arthur D. Little',
    'Avasant',
    'Avascent',
    'Bain & Company',
    'BDO Consulting',
    'Bearingpoint',
    'Berkeley Research Group, LLC',
    'Booz Allen Hamilton',
    'Boston Consulting Group',
    'Bow & Arrow',
    'The Burke Group',
    'Capco',
    'Capgemini Consulting',
    'CGI',
    'Cognizant Technology Solutions',
    'Computer Sciences Corporation',
    'Corporate Executive Board',
    'Deloitte Consulting',
    'Detica',
    'Ernst & Young',
    'Fulcrum Worldwide',
    'FTI Consulting',
    'Grant Thornton',
    'Hay Group',
    'HCL Axon',
    'Hewitt Associates',
    'Hitachi Consulting',
    'Horváth & Partners',
    'HP Enterprise Services',
    'Huron Consulting Group',
    'IBM Global Business Services',
    'ICF International',
    'Ikon Marketing Consultants',
    'Imdad logistics',
    'Infosys Consulting',
    'IPL Information Processing Limited',
    'ITN Consulting',
    'Korn Ferry',
    'KPMG',
    'Kurt Salmon',
    'L.E.K. Consulting',
    'Logica',
    'Marsh & McLennan Companies',
    'McGladrey',
    'McKinsey & Company',
    'Mercer',
    'Mitchell Madison Group',
    'Monitor Group',
    'Mott MacDonald',
    'Navigant Consulting',
    'Oliver Wyman',
    'PA Consulting Group',
    'Perficient',
    'PricewaterhouseCoopers',
    'Protiviti',
    'PRTM',
    'QualPro',
    'Rambøll Management',
    'Roland Berger Strategy Consultants',
    'The Saint Consulting Group',
    'Sapient',
    'Schlumberger Business Consulting',
    'SDG Group',
    'Simon-Kucher & Partners',
    'Slalom Consulting',
    'SM&A',
    'Strategy& (formerly Booz & Company)',
    'Tata Consultancy Services',
    'Towers Watson',
    'West Monroe Partners',
    'WS Atkins PLC',
    'PwC',
    'EY'
];

export default Step2;



// WEBPACK FOOTER //
// ./src/components/Membership/Step2/index.js